import { Store } from '@webtides/element-js';

/**
 * @property {Array<AccordionItem>} items
 */
export default class AccordionRegisterStore extends Store {
    items = [];

    /**
     * @param {HTMLElement} element
     */
    register(element) {
        if (!this.items.includes(element)) {
            this.items.push(element);
        }
        this.requestUpdate();
    }
}
